import type { ReactNode } from "react";

import type { IIconProps } from "@components/atoms/icon";
import type { IFastButtonProps } from "@components/fastFields/fastButton";
import type { IFastLinkButtonTypes } from "@components/fastFields/fastLinkButton";
import type { IModalProps } from "@components/atoms/modal";

export enum IAlertVariantsEnum {
  Information = "information",
  Error = "error",
  Warning = "warning",
  Success = "success",
  CustomIcon = "customIcon",
}

export enum IAlertButtonsTypeEnum {
  Basic = "basic",
  Stretch = "stretch",
}

export enum IAlertAlignmentEnum {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export interface IAlertProps extends IModalProps {
  title: string;
  description?: string;
  variant?: IAlertVariantsEnum;
  buttonsType?: IAlertButtonsTypeEnum;
  noIcon?: boolean;
  customIcon?: Omit<IIconProps, "customSize" | "fontSize">;
  submitButtonProps?: IFastButtonProps;
  cancelButtonProps?: IFastButtonProps;
  linkButtonType?: IFastLinkButtonTypes;
  alignment?: IAlertAlignmentEnum;
  noMaxWidth?: boolean;
  customChildren?: ReactNode | undefined;
}

export type IShowAlertParams = Omit<IAlertProps, "open">;

export interface IAlertStore {
  alertProps: IAlertProps;
  setAlertProps: (props: IAlertProps) => void;
  reset: () => void;
}

export type IAlertUtilProps = Omit<IAlertProps, "open">;
